export enum Platform {
  Unspecified = 'unspecified',
  Web = 'web',
  Desktop = 'desktop',
}
